import React from 'react';
import './AboutSection.css';

function AboutSection() {
    return (
        <section id="about" className="about">
            <h2 className="about__title">Sobre Nosotros</h2>
            <p className="about__text">
                Somos un grupo de apasionados por el paracaidismo con más de 10 años de experiencia
                brindando saltos inolvidables a miles de personas. Nuestro equipo está formado por
                instructores certificados que te acompañarán en cada paso para que vivas la mejor
                experiencia de tu vida.
            </p>
        </section>
    );
}

export default AboutSection;
